import { DialogDesignTokens } from '@primeng/themes/types/dialog';

export const dialogToken: DialogDesignTokens = {
  root: {
    borderRadius: '0.5rem',
    background: 'rgba(255, 255, 255, 0.8)',
    borderColor: 'transparent',
    shadow: '0px 0.25rem 1.25rem 0px rgba(0, 0, 0, 0.25)',
    color: '{gray.950}',
  },
  content: {
    padding: '0',
  },
};
